var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{grey: !_vm.code_flag},attrs:{"type":"button"},on:{"click":_vm.getPhoneCode}},[_vm._v(_vm._s(_vm.msg))])
}
var staticRenderFns = []

export { render, staticRenderFns }